var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import LensIcon from './LensIcon';
import { Theme, Size } from './types';
import { getContainerStyle, getTextStyle } from './utils';
export function FollowOnLens(_a) {
    var handle = _a.handle, _b = _a.theme, theme = _b === void 0 ? Theme["default"] : _b, _c = _a.size, size = _c === void 0 ? Size.medium : _c, title = _a.title;
    function navigate() {
        if (!handle.includes('.lens')) {
            handle = handle + '.lens';
        }
        var uri = "https://www.lensfrens.xyz/".concat(handle.toLowerCase(), "/follow");
        window.open(uri, '_newtab');
    }
    function handleWithoutLens() {
        if (handle.includes('.lens')) {
            handle = handle.split('.')[0];
        }
        return '@' + handle;
    }
    if (!title) {
        title = "Follow ".concat(handleWithoutLens(), " on Lens");
    }
    return (_jsxs("button", __assign({ onClick: navigate, style: getContainerStyle(theme, size) }, { children: [_jsx(LensIcon, { theme: theme, size: size }), _jsx("p", __assign({ style: getTextStyle(theme, size) }, { children: title }))] })));
}
//# sourceMappingURL=FollowOnLens.js.map